import * as i0 from '@angular/core';
import * as i1 from './accordion.module';
import * as i2 from '@angular/common';
import * as i3 from '../collapse/collapse.directive';
import * as i4 from './accordion.component';
import * as i5 from './accordion-group.component';
import * as i6 from '../collapse/collapse.module';
export const AccordionModuleNgFactory:i0.NgModuleFactory<i1.AccordionModule> = (null as any);
var _decl0_0:i2.NgClass = (<any>(null as any));
var _decl0_1:i2.NgComponentOutlet = (<any>(null as any));
var _decl0_2:i2.NgForOf<any> = (<any>(null as any));
var _decl0_3:i2.NgIf = (<any>(null as any));
var _decl0_4:i2.NgTemplateOutlet = (<any>(null as any));
var _decl0_5:i2.NgStyle = (<any>(null as any));
var _decl0_6:i2.NgSwitch = (<any>(null as any));
var _decl0_7:i2.NgSwitchCase = (<any>(null as any));
var _decl0_8:i2.NgSwitchDefault = (<any>(null as any));
var _decl0_9:i2.NgPlural = (<any>(null as any));
var _decl0_10:i2.NgPluralCase = (<any>(null as any));
var _decl0_11:i3.CollapseDirective = (<any>(null as any));
var _decl0_12:i4.AccordionComponent = (<any>(null as any));
var _decl0_13:i5.AccordionPanelComponent = (<any>(null as any));
var _decl0_14:i2.AsyncPipe = (<any>(null as any));
var _decl0_15:i2.UpperCasePipe = (<any>(null as any));
var _decl0_16:i2.LowerCasePipe = (<any>(null as any));
var _decl0_17:i2.JsonPipe = (<any>(null as any));
var _decl0_18:i2.SlicePipe = (<any>(null as any));
var _decl0_19:i2.DecimalPipe = (<any>(null as any));
var _decl0_20:i2.PercentPipe = (<any>(null as any));
var _decl0_21:i2.TitleCasePipe = (<any>(null as any));
var _decl0_22:i2.CurrencyPipe = (<any>(null as any));
var _decl0_23:i2.DatePipe = (<any>(null as any));
var _decl0_24:i2.I18nPluralPipe = (<any>(null as any));
var _decl0_25:i2.I18nSelectPipe = (<any>(null as any));
var _decl0_26:i2.CommonModule = (<any>(null as any));
var _decl0_27:i6.CollapseModule = (<any>(null as any));
var _decl0_28:i0.TemplateRef<any> = (<any>(null as any));
var _decl0_29:i0.ElementRef<any> = (<any>(null as any));
function _View_AccordionComponent_Host_1_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_12.closeOthers;
  currVal_0;
}
function _View_AccordionComponent_1_0():void {
  var _any:any = (null as any);
}
function _View_AccordionPanelComponent_Host_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = _decl0_13.isOpen;
  currVal_0;
}
function _View_AccordionPanelComponent_2_1():void {
  if (_decl0_13.heading) {
    var _any:any = (null as any);
    const currVal_0:any = 'btn btn-link';
    currVal_0;
    const currVal_1:any = {'text-muted':_decl0_13.isDisabled};
    currVal_1;
    const currVal_2:any = _decl0_13.heading;
    currVal_2;
  }
}
function _View_AccordionPanelComponent_2_0():void {
  var _any:any = (null as any);
  const currVal_0:any = 'panel card';
  currVal_0;
  const currVal_1:any = _decl0_13.panelClass;
  currVal_1;
  const currVal_2:any = _decl0_13.isOpen;
  currVal_2;
  const currVal_3:any = _decl0_13.heading;
  currVal_3;
  const currVal_4:any = !_decl0_13.isOpen;
  currVal_4;
  const currVal_5:any = _decl0_11.isCollapse;
  currVal_5;
  const currVal_6:any = _decl0_11.display;
  currVal_6;
  const currVal_7:any = _decl0_11.isExpanded;
  currVal_7;
  const currVal_8:any = _decl0_11.isExpanded;
  currVal_8;
  const currVal_9:any = _decl0_11.isExpanded;
  currVal_9;
  const currVal_10:any = _decl0_11.isCollapsed;
  currVal_10;
  const currVal_11:any = _decl0_11.isCollapsing;
  currVal_11;
  const pd_12:any = ((<any>_decl0_13.toggleOpen(_any)) !== false);
}
